import { useEffect } from 'react';
import { trackPageView, trackButtonClick } from '@/services/analytics';

export const usePageTracking = (pageName, additionalData = {}) => {
  useEffect(() => {
    trackPageView(pageName, {
      ...additionalData,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString()
    });
  }, [pageName]);
};

export const useButtonTracking = () => {
  const trackClick = (buttonName, location, additionalData = {}) => {
    trackButtonClick(buttonName, location, additionalData);
  };

  return { trackClick };
}; 